export default {
  signInVerification: (ssoServerHost, token, siteKey) => {
    window.location = `${ssoServerHost}/sign_in_verification/${token}?to=${siteKey}`
  },
}
